if ('scrollRestoration' in history) {
	history.scrollRestoration = 'manual';
}

window.addEventListener('beforeunload', () => {
	sessionStorage.setItem('scroll:' + window.location.href, String(window.scrollY));
});

(function () {
	const currentHref = window.location.href;
	const grid = document.getElementById('product-grid');

	if (grid) {
		// Save clicked product URL so we can scroll back to it on return
		grid.addEventListener('click', e => {
			const link = e.target.closest('a[href*="/products/"]');
			if (link) sessionStorage.setItem('return-to-product:' + currentHref, link.href);
		});

		const returnTo = sessionStorage.getItem('return-to-product:' + currentHref);
		if (returnTo) {
			sessionStorage.removeItem('return-to-product:' + currentHref);

			let userScrolled = false;
			window.addEventListener('wheel', () => { userScrolled = true; }, { once: true, passive: true });
			window.addEventListener('touchmove', () => { userScrolled = true; }, { once: true, passive: true });

			let returnToPath;
			try { returnToPath = new URL(returnTo).pathname; } catch (e) { returnToPath = returnTo; }

			const scrollToCard = () => {
				for (const a of grid.querySelectorAll('a[href*="/products/"]')) {
					try {
						if (new URL(a.href).pathname === returnToPath) {
							(a.closest('li') || a).scrollIntoView({ block: 'center' });
							return true;
						}
					} catch (e) { /* skip malformed href */ }
				}
				return false;
			};

			// Fetch the next Ajaxinate page and append its items silently — no scrolling
			const loadNextPage = async () => {
				const nextLink = document.querySelector('#AjaxinatePagination a');
				if (!nextLink) return false;
				try {
					const res = await fetch(nextLink.href);
					if (!res.ok) return false;
					const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
					const newItems = doc.querySelector('#product-grid');
					if (newItems) grid.insertAdjacentHTML('beforeend', newItems.innerHTML);
					const newPagination = doc.querySelector('#AjaxinatePagination');
					if (newPagination) document.querySelector('#AjaxinatePagination').innerHTML = newPagination.innerHTML;
					return !!newItems;
				} catch (e) { return false; }
			};

			requestAnimationFrame(async () => {
				// Product is on page 1 — already in DOM
				if (scrollToCard()) return;

				// Product is on page 2+ — silently fetch pages until the card appears
				for (let i = 0; i < 10 && !userScrolled; i++) {
					if (!await loadNextPage()) break;
					if (scrollToCard()) return;
				}
			});

			return;
		}
	}

	// No specific product to return to — restore pixel scroll position
	const stored = sessionStorage.getItem('scroll:' + currentHref);
	if (!stored) return;

	const targetY = Number(stored);
	let attempts = 0;
	let userScrolled = false;
	const onUserInput = () => { userScrolled = true; };
	window.addEventListener('wheel', onUserInput, { once: true, passive: true });
	window.addEventListener('touchmove', onUserInput, { once: true, passive: true });

	const cleanup = () => {
		window.removeEventListener('wheel', onUserInput);
		window.removeEventListener('touchmove', onUserInput);
	};

	const tryRestore = () => {
		if (userScrolled || attempts++ >= 30) { cleanup(); return; }
		window.scrollTo(0, targetY);
		if (window.scrollY >= targetY - 100) { cleanup(); return; }
		setTimeout(tryRestore, 300);
	};

	requestAnimationFrame(tryRestore);
}());
